export default class SaveProfileRequest {
    userId: String;
    accountId: String;
    firstName: String;
    lastName: String;
    email: String;
    title: String;
    department: String;
    phone: String;
    address1: String;
    address2: String;
    city: String;
    state: String;
    postalCode: String;
    prefix: String;
    changePassword: Boolean = false; // todo -remove this field
    newPassword: String;
    passwordAgain: String;
}